module.exports = __webpack_public_path__ + "img/cancel.152da400.svg";